// src/constants/voiceover.ts
/**
 * Voiceover Word Limit Constants (Frontend)
 * Mirrors convex/lib/voiceoverConstants.ts for client-side validation
 */

/** Minimum words per scene */
const MIN_WORDS_PER_SCENE = 6;

/** Maximum words per scene */
export const MAX_WORDS_PER_SCENE = 24;

/** Words per second for duration estimation (ElevenLabs TTS pace) */
export const WORDS_PER_SECOND = 5.5;

/** Max audio duration (seconds) for regular (non-avatar) scenes */
export const DURATION_LIMIT_REGULAR = 7;

/** Max audio duration (seconds) for avatar_only scenes */
export const DURATION_LIMIT_AVATAR = 10;

/**
 * Count words in text
 */
function countWords(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length;
}

/**
 * Validate voiceover word count for UI feedback
 */
export function validateVoiceoverWordCount(text: string): {
  isValid: boolean;
  wordCount: number;
  isOverLimit: boolean;
  isUnderLimit: boolean;
} {
  const wordCount = countWords(text);
  const isOverLimit = wordCount > MAX_WORDS_PER_SCENE;
  const isUnderLimit = wordCount < MIN_WORDS_PER_SCENE;

  return {
    isValid: !isOverLimit && !isUnderLimit,
    wordCount,
    isOverLimit,
    isUnderLimit,
  };
}

/**
 * User-facing notification message for word limit exceeded
 */
export const WORD_LIMIT_EXCEEDED_MESSAGE =
  'Voiceover text exceeds 24 words (~4.4 seconds). For longer narration, add more scenes to your video. Each scene works best with short, impactful phrases.';
